import { Directive } from '@angular/core';
import { GtmTrackSelectItemAbstract } from '@df/module-gtm/track/select-item/gtm-track-select-item.abstract';

/**
 * Directive to track `select_item` event.
 * This event signifies an item was selected from a list.
 *
 * `gtmTrackSelectItem` is an object with the following properties:
 * - `itemId` (string): The ID of the list in which the item was presented to the user. Example value	`related-products`
 * - `itemName` (string): The name of the list in which the item was presented to the user. Example value	`Related Products`
 * - `index` (number): The index/position of the item in a list.
 * - `model` (Product): Selected item from a list.
 *
 * @example
 * ```html
 * <a [gtmTrackSelectItem]="gtmTrackSelectItem">...</a>
 * ```
 */
@Directive({
    selector: '[gtmTrackSelectItem]',
    standalone: true
})
export class GtmTrackSelectItemDirective extends GtmTrackSelectItemAbstract {}
